// extracted by mini-css-extract-plugin
export default {"root":"Preview_root__-y+eQ","skeleton":"Preview_skeleton__sioST"};